export default __webpack_public_path__ + "static/media/pulmonology.a952a6ff.jpg";